
 // LP-01 · Diwali Pro Offer — page copy and offer rules.
// Source: 02 - Copy/LP-01-diwali-pro-offer-copy-v1.md (copy) and the LP-01 dev brief (rules).
// Edit copy here; components only lay it out.

export const LP_ID = "LP-01";
export const OFFER_CODE = "diwali_pro_2499";
export const CONSENT_TEXT_VERSION = "lp01-v1-2026-10-07";

// 11 November 2026, 23:59 IST
export const OFFER_END = new Date("2026-11-11T23:59:59+05:30");

// Each landing page is served from its own subdomain root.
export const PATHS = {
  page: "/",
  thankYou: "/thank-you/",
};

export const price = {
  regular: "₹3,499",
  offer: "₹2,499",
  savingMonthly: "₹1,000",
  savingTotal: "₹3,000",
  offerValue: 2499,
};

export const meta = {
  title: "WhatsApp Business API at ₹2,499/month | Onbbits Diwali Offer",
  description:
    "Get Onbbits Pro, the official WhatsApp Business API with 20 agents and 5 chatbot flows, for ₹2,499/month for 3 months. Free setup. No lock-in. Ends 11 Nov.",
};

export const hero = {
  /* badges: ["Meta Tech Provider", "Official WhatsApp Business API"], */
  // H1 renders as: This {festival}{h1Rest} {h1Accent}
  h1Festival: "Diwali",
  h1Rest: ", get the official WhatsApp Business API for",
  h1Accent: "₹2,499/month.",
  sub: "Onbbits Pro with 20 team agents and 5 chatbot flows, set up free by our team.",
  priceSuffix: "/month for your first 3 months",
  cta: "Claim Diwali offer",
  microcopy: ["+ 18% GST", "Billed monthly", "No lock-in, cancel anytime"],
  chips: ["Instant reply · day or night", "Reminder sent · on schedule"],
  ended: {
    h1: "The Diwali offer has ended.",
    sub: "Onbbits Pro is available at our current pricing. Questions? Call or write to our team.",
    cta: "See current Pro pricing",
  },
};

export const heroChat = {
  business: "Your business",
  customer: "Hi, saw your Diwali offer ad. Price kya hai?",
  reply:
    "Happy Diwali! Thanks for reaching out. Want our price list, or should someone from the team help you?",
  buttons: ["See price list", "Talk to the team"],
  reminderLabel: "Next day · reminder",
  reminder:
    "Still looking for a quote before Diwali? Reply and our team will share options in your budget.",
};

export const teaseMessages = [
  "Is there a slot tomorrow?",
  "Site visit kab ho sakti hai?",
  "Size M available hai?",
  "Modular kitchen ka quote?",
  "Test drive this Saturday?",
  "4 baje free ho?",
  "Table for 6 tonight?",
  "Am I eligible?",
  "Package for 4 people?",
  "Dealer price list bhejo",
  "Fees and batch timings?",
  "Can you send a quote?",
];

export const teaseCaption =
  "Whatever your customers ask, Onbbits replies in seconds.";

export const trust = [
  {
    title: "Official WhatsApp Business API",
    text: "follows Meta's messaging rules",
  },
  {
    title: "Free setup by our team",
    text: "this Diwali",
  },
  {
    title: "No lock-in",
    text: "billed monthly, cancel anytime",
  },
];

export const speed = {
  eyebrow: "Why speed decides the sale",
  h2Lead: "Every hour you don't reply,",
  h2Accent: "someone else already has.",
  body: "Your ad did its job the moment they tapped “Send”. What happens in the next few minutes decides whether that enquiry becomes your customer, or someone else's.",
  stat: "21×",
  statText:
    "more likely to qualify a lead when you respond within 5 minutes instead of 30.",
  source:
    "Lead Response Management Study, Dr. James Oldroyd (MIT) with InsideSales.com, 2007.",
};

export const steps = {
  eyebrow: "How it works",
  h2Lead: "From first message to ready-to-close.",
  h2Accent: "Without you chasing.",
  items: [
    {
      title: "A customer messages you",
      text: "From your ad, your Google listing or your website, at any hour.",
      example: "“Is there a slot tomorrow?” at 11 PM.",
    },
    {
      title: "Instant reply, right questions",
      text: "Your chatbot flow answers in seconds and asks what your team would: budget, area, timing.",
      example: "“What budget and area are you looking at?”",
    },
    {
      title: "Reminders if they go quiet",
      text: "Schedule reminder messages so quiet leads hear from you again.",
      example:
        "“Still thinking about the test drive? Reply and our team will help.”",
    },
    {
      title: "Handed to your team",
      text: "Your team picks up the chat in a shared inbox, with the answers already in hand.",
      example: "“Modular kitchen · 10×8 ft · budget ₹2–3 lakh.”",
    },
  ],
};

export const offer = {
  tag: "Diwali offer · ends 11 November",
  h2Lead: "Onbbits Pro for ₹2,499/month.",
  h2Accent: "Set up free by our team.",
  card: {
    name: "Onbbits Pro",
    badge: "Save ₹3,000",
    descriptor: "For growing teams that need full automation at scale.",
    underPrice: "for your first 3 months · save ₹1,000 a month",
    terms: [
      "Then ₹3,499/month",
      "Billed monthly",
      "18% GST applicable",
      "No lock-in, cancel anytime",
    ],
    gift: "+ Free setup by our team",
    giftLabel: "Diwali gift",
    featuresTop: [
      "1 owner + 20 team agents included",
      "5 chatbot flows",
      "Shared inbox, broadcasts & campaigns",
      "Up to 50 reminder messages a day",
      "Catalogues, product messages & orders",
      "Agent transfer & manager monitoring",
    ],
    featuresMore: [
      "Up to 1,000 templates",
      "200 tags · 15 custom attributes",
      "25 audience segments",
      "Swipeable carousel messages",
      "20 WhatsApp forms",
      "AI template writing (100 generations)",
      "API access · 500 requests/minute",
      "5 GB storage · analytics & reporting",
    ],
    moreLabel: "See all Pro features",
    rates: [
      ["Marketing", "₹0.95"],
      ["Utility", "₹0.127"],
      ["Authentication", "₹0.127"],
      ["Service", "₹0.127"],
    ],
    ratesTitle: "Message rates · per message, billed separately",
    ratesFree: "First 1,000 service messages free every month",
    ratesLink: "View full charges",
    ratesNote:
      "Reminders sent after a customer has been silent for 24 hours are template messages and are charged at these rates.",
  },
};

export const form = {
  heading: "Claim your Diwali offer",
  sub: "Tell us about your business. Our team will reach you on WhatsApp to set you up.",
  steps: ["About you", "Get you live faster"],
  continue: "Continue",
  back: "Back",
  submit: "Claim Diwali offer",
  submitting: "Sending…",
  underButton:
    "You'll hear from our team on WhatsApp shortly. No payment on this page.",
  errorPrefix: "Please complete:",
  networkError:
    "We couldn't send your details. Please try again, or call us.",
  consent:
    "I agree that Onbbits Innovation Pvt. Ltd. may contact me on WhatsApp and phone about this enquiry and process the details above for that purpose, as per the Privacy Policy. I can withdraw consent anytime by replying STOP or writing to info@onbbits.io.",
  optIn: "Send me product updates and offers on WhatsApp.",
  finePrint:
    "Offer price applies to the first 3 monthly payments on new Pro subscriptions made by 11 November 2026. From month 4, Pro is billed at ₹3,499/month + GST. Cancel anytime; your plan stays active until the end of the month you've paid for. Message charges are billed separately.",
  businessTypes: [
    "Healthcare & clinics",
    "Real estate",
    "Interiors & home",
    "E-commerce, D2C & retail",
    "Banking, finance & insurance",
    "Restaurants & F&B",
    "Automobile",
    "Salons & spa",
    "Education & coaching",
    "Events & webinars",
    "Travel & hospitality",
    "Manufacturing & B2B",
    "IT services & agencies",
    "Other",
  ],
  enquiryOptions: ["Under 50", "50–300", "300+"],
};

export const comparison = {
  eyebrow: "Free app vs official API",
  h2Lead: "The free app is for chatting.",
  h2Accent: "The API is for selling.",
  colApp: "WhatsApp Business app · free",
  colApi: "Onbbits Pro · official API",
  rows: [
    [
      "Broadcast reach",
      "Lists cap at 256, and only reach people who saved your number",
      "Message any customer who opted in, by tags and segments",
    ],
    [
      "New enquiries",
      "Basic greeting and away messages",
      "Chatbot flows reply instantly, with buttons",
    ],
    [
      "Following up",
      "Only if someone remembers",
      "Scheduled reminder messages",
    ],
    [
      "Your team",
      "One phone, a few linked devices",
      "20 agents in a shared inbox, with chat transfer",
    ],
    [
      "Selling in chat",
      "Basic catalogue",
      "Catalogues, product messages, carousels and orders",
    ],
    [
      "Number safety",
      "Bulk sending from the app can get a number banned",
      "Runs on Meta's official API, inside Meta's rules",
    ],
  ],
  band: {
    title: "Ready to move to the official API?",
    text: "₹2,499/month this Diwali, set up free.",
  },
};

export const industries = {
  eyebrow: "See it for your business",
  h2Lead: "Ready-made flows for",
  h2Accent: "your kind of business.",
  sub: "Pick yours and see how a first conversation looks.",
  note: "We start you on a ready-made flow for your industry. Connects with ERPNext and WooCommerce, so leads and orders flow into the systems you already run.",
  items: [
    {
      id: "real-estate",
      label: "Real estate",
      ask: "2BHK ke options hai?",
      reply: "Hi! What budget and area are you looking at?",
      buttons: ["Under ₹50 lakh", "₹50 lakh – 1 crore", "Request a site visit"],
      reminderLabel: "Next day",
      reminder: "Two new options in your budget. Want the brochure?",
    },
    {
      id: "clinic",
      label: "Clinic",
      ask: "Teeth whitening ka price kya hai?",
      reply: "Would you like the price list or a callback from the clinic?",
      buttons: ["Price list", "Request a callback", "Talk to the clinic"],
      reminderLabel: "Day 2",
      reminder: "Still thinking about it? Reply and we'll call you.",
    },
    {
      id: "interiors",
      label: "Interiors",
      ask: "Modular kitchen quote chahiye.",
      reply: "Share your kitchen size and we'll send a rough quote.",
      buttons: ["Share size", "See past work", "Request a measurement"],
      reminderLabel: "Day 2",
      reminder: "Here are 3 kitchens we finished last month.",
    },
    {
      id: "retail",
      label: "Retail / D2C",
      ask: "Is this available in size M?",
      reply: "Yes, it's in stock. Want to see more colours or order?",
      buttons: ["See colours", "Order now", "Talk to us"],
      reminderLabel: "Next day",
      reminder: "Your size is still in stock. Shall we keep one aside?",
    },
    {
      id: "automobile",
      label: "Automobile",
      ask: "Test drive this Saturday?",
      reply: "Which model are you looking at?",
      buttons: ["SUV", "Sedan", "Request a test drive"],
      reminderLabel: "Day 3",
      reminder:
        "Still keen on the test drive? Reply and our team will set it up.",
    },
    {
      id: "salon",
      label: "Salon & spa",
      ask: "4 baje free ho?",
      reply: "Which service are you looking for?",
      buttons: ["Hair", "Skin", "Talk to the salon"],
      reminderLabel: "Next day",
      reminder:
        "Want us to hold a slot this week? Reply and we'll confirm.",
    },
    {
      id: "restaurant",
      label: "Restaurant",
      ask: "Table for 6 tonight?",
      reply: "Happy to help! What time works for you?",
      buttons: ["7–8 PM", "8–9 PM", "Call me"],
      reminderLabel: "Same day",
      reminder:
        "Still planning dinner? Reply and we'll check availability.",
    },
    {
      id: "finance",
      label: "Finance",
      ask: "Am I eligible for a loan?",
      reply: "Which kind of loan are you looking for?",
      buttons: ["Home", "Business", "Talk to an advisor"],
      reminderLabel: "Day 2",
      reminder: "Want an advisor to call you today?",
    },
  ],
};

export const faq = {
  eyebrow: "Common questions",
  h2: "Frequently asked questions.",
  items: [
    [
      "What is the WhatsApp Business API?",
      "Meta's official way for businesses to message customers at scale: automated replies, a shared team inbox, reminders and broadcasts to opted-in customers. Onbbits connects you to it.",
    ],
    [
      "What's the Diwali offer?",
      "Onbbits Pro at ₹2,499/month instead of ₹3,499 for your first 3 months, plus free setup by our team. Billed monthly, + 18% GST. Ends 11 November 2026.",
    ],
    [
      "What happens after 3 months?",
      "Pro continues at ₹3,499/month + GST. You can cancel anytime before that.",
    ],
    [
      "Is there a lock-in? What if I cancel?",
      "No lock-in. Cancel anytime; your plan stays active until the end of the month you've paid for.",
    ],
    [
      "Why not just start on the free plan?",
      "The free plan lets you try the basics. Pro adds 20 agents, 5 chatbot flows, catalogues, carousels and 50 reminders a day, and this Diwali you get it at ₹2,499 with setup done for you.",
    ],
    [
      "Are message charges included?",
      "No. They're billed per message: Marketing ₹0.95, Utility, Authentication and Service ₹0.127, and the first 1,000 service messages each month are free.",
    ],
    [
      "Will my customers know it's a bot?",
      "Replies come from your business number, in your words. You decide what's automated, and your team can take over any chat.",
    ],
    [
      "Why do you ask for GST, website and Meta Business Portfolio?",
      "They're what you need to go live on the official API. Don't have one yet? Choose “No” and we'll guide you.",
    ],
    [
      "How fast can I go live?",
      "Live in 30 minutes once your GST, website and Meta Business Portfolio are ready. Our team does the setup.",
    ],
    [
      "What kind of business does Onbbits work for?",
      "Any business whose customers message on WhatsApp. Clinics, brokers, showrooms, salons, restaurants, stores, institutes and B2B suppliers all use the same pattern: reply fast, ask the right questions, follow up, hand over to your team.",
    ],
  ],
};

export const finalCta = {
  tag: "Diwali offer · ends 11 November",
  h2: "Make WhatsApp sell this Diwali.",
  sub: "Onbbits Pro at ₹2,499/month for 3 months, plus free setup. No lock-in.",
};

export const thankYou = {
  tag: "Diwali offer · Pro at ₹2,499/month",
  h1: "Your Diwali offer is reserved.",
  sub: "One last step: continue on WhatsApp to get your setup started.",
  button: "Continue on WhatsApp",
  buttonSub: "Opens a chat with the Onbbits team",
  nextTitle: "What happens next",
  next: [
    "An instant reply on WhatsApp, the same speed your customers will get.",
    "A few quick questions about your business and enquiries.",
    "Our sales team sends your Pro activation link at ₹2,499/month.",
    "Your free setup is scheduled with our team. Live in 30 minutes once your GST, website and Meta Business Portfolio are ready.",
  ],
  waText: (businessType) =>
    `Hi, I claimed the Diwali Pro offer – ${businessType || "my business"}`,
  back: "Back to the offer",
};
